import { Injectable } from "@angular/core";
import moment from "moment";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { ListColumn } from "../../../../../core/list/list-column.model";
import { DataGridService } from "../../../../shared/data-grid/data-grid.service.interface";
import { DropDownListDTO } from "../../../../shared/dto-models/dropDownListDTO.model";
import { ServiceSummaryDTO } from "../../../../shared/dto-models/serviceSummaryDTO.model";
import { IDataGrid } from "../../../../shared/models/dataGrid.model";
import { ConfigurationService } from "../../../../shared/services/configuration.service";
import { DataService } from "../../../../shared/services/data.service";

@Injectable()
export class ServiceAddService implements DataGridService<ServiceSummaryDTO> {
  private ePermitsUrl = " ";

  constructor(
    private service: DataService,
    private configurationService: ConfigurationService,
  ) {
    if (this.configurationService.isReady) {
      this.ePermitsUrl = this.configurationService.serverSettings.ePermitsUrl;
    } else {
      this.configurationService.settingsLoaded$.subscribe(
        (x) =>
          (this.ePermitsUrl =
            this.configurationService.serverSettings.ePermitsUrl),
      );
    }
  }

  copyRow(id: number): Observable<number> {
    return 0 as any;
  }

  getData(
    pageSize?: number,
    startRow?: number,
    sortActive?: string,
    sortDirection?: string,
    filters?: ListColumn[],
  ): Observable<IDataGrid<ServiceSummaryDTO>> {
    let url = `${this.ePermitsUrl}/api/v1/asset/services?pageSize=${pageSize}&pageIndex=${startRow}&sortActive=${sortActive}&sortDirection=${sortDirection}`;

    filters.forEach((filter) => {
      if (filter.filterValue || filter.filterValue === 0) {
        if (filter.filterValue instanceof Array) {
          url = `${url}&${filter.property}=${moment(
            filter.filterValue[0],
          ).format("YYYY-MM-DD HH:mm:ss")}|${moment(
            filter.filterValue[1],
          ).format("YYYY-MM-DD HH:mm:ss")}`;
        } else {
          url = `${url}&${filter.property}=${encodeURIComponent(
            filter.filterValue,
          )}`;
        }
      }
    });

    return this.service.get(url).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }

  changeStatus(command: any): Observable<true> {
    throw new Error("Method not implemented.");
  }

  getDropDownList(resource: string): Observable<DropDownListDTO[]> {
    const url = `${this.ePermitsUrl}/api/v1/asset/${resource}`;

    return this.service.get(url).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }

  private isObject(value) {
    return value && typeof value === "object" && value.constructor === Object;
  }

  hasGotChildren(id: any): Observable<boolean> {
    return of(false);
  }
}
